export default __webpack_public_path__ + "static/media/Developing.86a56e8a.png";